import * as yup from 'yup';



// ------ form types
export const PHONE_CALLING_CODE_MAX = 998;
export const PHONE_CALLING_CODE_MIN = 0;

export const PHONE_NUMBER_MAX = 30;
export const PHONE_NUMBER_MIN = 5;


// ------ schema
export const SCHEMA_PHONE_FORM = yup.object()
    .shape({
        callingCode: yup.number()
            .nullable()
            .min(PHONE_CALLING_CODE_MIN)
            .max(PHONE_CALLING_CODE_MAX)
            .required(),
        countryAlpha2: yup.string()
            .nullable()
            .length(2)
            .required(),
        number: yup.string()
            .nullable()
            .min(PHONE_NUMBER_MIN)
            .max(PHONE_NUMBER_MAX)
            .required()
            .phoneNumber()
    })
    .phone();
